<template>
    <div class="pagination">
        <a @click="onPageStartChange(1)" :class="parseInt(currentPage) <= 1? 'btn-prev-more disableCss' : 'btn-prev-more'" @mouseover="hoverPage('prev_more');" @mouseleave="leavePage('prev_more')">
            <img v-if="hoverImg == 'prev_more'" src="@/assets/img/board/left-arrow-more-hover.svg"/>
            <img v-if="hoverImg != 'prev_more'"  src="@/assets/img/board/left-arrow-more.svg"/>
        </a>
        <!-- <a @click="onPageChange(currentPage - 1)" class="btn-prev" v-if="currentPage != 1"> -->
        <a @click="onPageChange(currentPage - 1)" :class="parseInt(currentPage) <= 1? 'btn-prev disableCss' : 'btn-prev'" @mouseover="hoverPage('prev');" @mouseleave="leavePage('prev')">
            <img v-if="hoverImg == 'prev'" src="@/assets/img/board/left-arrow-hover.svg"/>
            <img v-if="hoverImg != 'prev'" src="@/assets/img/board/left-arrow.svg"/>
        </a>
        <a v-for="(paging, index) in pages" :key="index" @click="onPageChange(paging)">
            <span :class="paging == currentPage ? 'selected' : ''">{{paging}}</span>
        </a>
        <!-- <a @click="onPageChange(currentPage + 1)" class="btn-next" v-if="currentPage != totalPages"> -->
        <a @click="onPageChange(parseInt(currentPage) + 1)" :class="parseInt(currentPage) >= totalPages? 'btn-next disableCss' : 'btn-next'" @mouseover="hoverPage('next');" @mouseleave="leavePage('next')">
            <img v-if="hoverImg == 'next'" src="@/assets/img/board/right-arrow-hover.svg"/>
            <img v-if="hoverImg != 'next'" src="@/assets/img/board/right-arrow.svg"/>
        </a>
        <a @click="onPageEndChange(totalPages)" :class="parseInt(currentPage) >= totalPages? 'btn-next-more disableCss' : 'btn-next-more'" @mouseover="hoverPage('next_more');" @mouseleave="leavePage('next_more')">
            <img v-if="hoverImg == 'next_more'" src="@/assets/img/board/right-arrow-more-hover.svg"/>
            <img v-if="hoverImg != 'next_more'" src="@/assets/img/board/right-arrow-more.svg"/>
        </a>
    </div>
</template>
<script>
    export default {
        name: 'Pagination',
        props : ['currentPage', 'totalPages', 'pageSize', 'code', 'category'],
        data() {
            return {
                hoverImg: "",
            }
        },
        computed: {
            pages: function() {
                const list = [];
                for (let index = this.startPage; index <= this.endPage; index += 1) {
                    list.push(index);
                }
                return list;
            },
            startPage() {
                return parseInt(parseInt(parseInt(parseInt(this.currentPage - 1) / this.pageSize) * this.pageSize) + 1);
            },
            endPage() {
                let lastPage = parseInt(this.startPage + this.pageSize - 1);
                return lastPage <= this.totalPages ? lastPage : this.totalPages;
            }
        },
        methods: {
            onPageChange(val) {
                if (val <= 0) {
                    return;
                }
                if (val > this.totalPages) {
                    return;
                }
                // this.$emit("pageChange", val);
                if(this.category) {
                    location.href='/kr/board/security/list/' + this.code + '?page=' + val + '&category=' + this.category;
                } else {
                    location.href='/kr/board/security/list/' + this.code + '?page=' + val;
                }
            },
            onPageStartChange(val) {
                if(this.currentPage == 1) return;
                this.onPageChange(val);
            },
            onPageEndChange(val) {
                if(this.currentPage == this.totalPages) return;
                this.onPageChange(val);
            },
            hoverPage(btn) {
                this.hoverImg = btn;
            },
            leavePage(btn) {
                this.hoverImg = "";
            }
        }
    }
</script>
<style>
@import '../../assets/css/board/pagination.css'
</style>